import { render, staticRenderFns } from "./ProfileVideos.vue?vue&type=template&id=c45217f2&scoped=true"
import script from "./ProfileVideos.js?vue&type=script&lang=js&external"
export * from "./ProfileVideos.js?vue&type=script&lang=js&external"
import style0 from "./ProfileVideos.vue?vue&type=style&index=0&id=c45217f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45217f2",
  null
  
)

export default component.exports